import { render, staticRenderFns } from "./CompetenciesLogo.vue?vue&type=template&id=327d2c80&"
import script from "./CompetenciesLogo.vue?vue&type=script&lang=ts&"
export * from "./CompetenciesLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports